import { render, staticRenderFns } from "./StudentFees.vue?vue&type=template&id=4b0b5988&scoped=true&"
import script from "./StudentFees.vue?vue&type=script&lang=js&"
export * from "./StudentFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b5988",
  null
  
)

export default component.exports